// src/AppRouter.tsx

import React, { FunctionComponent, Suspense } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import App from './App'
import AppBeta from './AppBeta'

const AppRouter: FunctionComponent = () => {
  const RouterComponent = Router as any
  const SwitchComponent = Switch as any
  const RouteComponent = Route as any
  return (
    <RouterComponent>
      <RecoilRoot>
        <Suspense fallback={<span>Loading...</span>}>
          <SwitchComponent>
            <RouteComponent exact path="/" component={App} />
            <RouteComponent exact path="/beta" component={AppBeta} />
          </SwitchComponent>
        </Suspense>
      </RecoilRoot>
    </RouterComponent>
  )
}

/*
    EE: To replace Recoil state management with Redux Toolkit;

    import { Provider } from 'react-redux'
    import store from './redux/store'

    <Router>
      <Provider store={store}>
        <Switch>
          <Route exact path="/" component={App} />
        </Switch>
      </Provider>
    </Router>
 */

export default AppRouter
